import { useQuery } from "@tanstack/react-query";

import {
  getSubscriptionOverviewQueryOptions,
  getSubscriptionPlansQueryOptions,
} from "../query-options";

export function useSubscriptionPlansQuery() {
  return useQuery(getSubscriptionPlansQueryOptions());
}

export function useSubscriptionOverviewQuery(userId: string) {
  return useQuery({
    ...getSubscriptionOverviewQueryOptions(userId),
    enabled: Boolean(userId),
  });
}
